// ホーム（ダッシュボード）に出す入口。今日の一枚があればそのカード、なければ未来ボードへの入口。
// 今日の一枚は「表示中」のカードだけ（表示中でなくなると、サーバーが固定を外す）。
import type { FutureCardList, FutureCardSummary } from "../../api/futureBoard";

export type HomeEntry =
  | { kind: "pinned"; card: FutureCardSummary }
  | { kind: "board" };

export function homeEntry(list: Pick<FutureCardList, "cards" | "pinned_card_id"> | null | undefined): HomeEntry {
  if (list && list.pinned_card_id !== null && list.pinned_card_id !== undefined) {
    const card = list.cards.find(item => item.id === list.pinned_card_id && item.status === "visible");
    if (card) return { kind: "pinned", card };
  }
  return { kind: "board" };
}

// 入口から開く先（ワンシーンか、ボード）。Web のパスと、モバイルの画面のパラメーターで共通に使う。
export function homeTarget(entry: HomeEntry): { cardId: number | null } {
  return { cardId: entry.kind === "pinned" ? entry.card.id : null };
}
